import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Parallax } from 'react-scroll-parallax';

const useStyles = makeStyles((theme) => ({
  container: {
    zIndex: 1,
    width: "100%",
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "5em 2em",
    position: "relative",

    [theme.breakpoints.down('md')]: {
      paddingLeft: "1em",
      paddingRight: "1em",
    }
  },

  heroImage: {
    zIndex: 3,
    width: "85%",
    borderRadius: "20px",
    marginLeft: "auto",
    marginRight: "auto",
    boxShadow: "0 13px 40px 7px rgba(0, 0, 0, .25)",

    width: "100%",
    borderRadius: "10px",
  },

  dashboardText: {
    color: "#f5f5f7",
    fontSize: "215px",
    fontWeight: 600,

    [theme.breakpoints.down('md')]: {
      fontSize: "115px",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: "100px",
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: "80px",
    },

  }
}));

export default function ShowCaseSection() {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <div style={{
        position: "relative"
      }}>
        <Parallax scale={[0.4, 1]} easing='ease' >
          <div
            style={{
              display: "flex",
            }}
          >
            <img className={classes.heroImage} srcset="images/logged_out/dashboard-300.webp 320w, images/logged_out/dashboard-1200.webp 1400w" sizes="(max-width: 520px) 320px, 1400px" alt="Dashboard showcase" />
          </div>
        </Parallax>
        <Parallax style={{ position: 'absolute', bottom: "-130px", zIndex: "-1" }} translateX={['50%', '-20%']} easing='easeOut' >
          <div aria-hidden="true" className={classes.dashboardText}>Dashboard</div>
        </Parallax>
      </div>

    </Box>

  );
}
